import { defineStore } from "pinia";
import { ref } from "vue";

export const useVersionStore = defineStore("version", () => {

  const newVersionAvailable = ref(false);
  const newVersion = ref(null);

  const markNewVersion = function (version) {
    newVersion.value = version;
    newVersionAvailable.value = true;
  }

  const applyUpdate = function () {
    window.location.reload();
  }

  return { newVersionAvailable, newVersion, markNewVersion, applyUpdate };
});
